'use client';
import { useRef as n, useEffect as o } from "react";
function c(r) {
  const e = n(null);
  return o(() => {
    e != null && e.current && e.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  }, [r]), e;
}
export {
  c as useScrollableRef
};
